<script setup lang="ts">
import { useRenderStore } from '@/builder/stores/renderStore';
import { computed, onMounted, ref } from 'vue';

const props = defineProps<{
    id: string;
    text: string;
    duration: number | null;
}>();

// injects
const renderStore = useRenderStore();

// refs
const selfRemovalTimeout = ref<any>(null);
const removalTimeout = ref<any>(null);

// methods
const closeError = () => {
    // clear the self removal timeout
    if (selfRemovalTimeout.value) {
        clearTimeout(selfRemovalTimeout.value);
    }

    removalTimeout.value = setTimeout(() => {
        renderStore.clearToast(props.id);
    }, 300);
};

// computed
const id = computed(() => `errorItem_${props.id}`);

// lifecycle
onMounted(() => {
    if (props.duration) {
        selfRemovalTimeout.value = setTimeout(() => {
            closeError();
        }, props.duration);
    }
});

</script>

<template>
    <li :id="id" class="content error-item">
        <p class="mb-0" :id="id">{{ text }}</p>
    </li>
</template>
